import {
  combineReducers,
  createStore
} from 'redux'
import {
  reducer as formReducer
} from 'redux-form'

import navigation from './navigation'
import auth from './auth'
import dialog from './dialog'
import loading from './loading'
import navbar from './navbar'
import editor from './editor'
import generic from './generic'
import upload from './upload'
import sidebar from './sidebar'
import confirm from './confirm'

import baseinfo from './baseInfo/baseinfo'
import rating from './baseInfo/rating'

import { routerReducer } from 'react-router-redux'

import {
  unauthorizeUser
} from '../_actions/auth'
import {
  receiveMockState
} from '../_actions/mock'

const form = () => formReducer

const getNewReducer = _ =>
  combineReducers(
    Object.entries({
      navigation,
      auth,
      dialog,
      form,
      loading,
      navbar,
      editor,
      generic,
      upload,
      sidebar,
      confirm,

      baseinfo,
      rating,


      routing: routerReducer
    }).reduce(
      (acc, [key, value]) => ({
        ...acc,
        [key]: value()
      }), {}
    )
  )

const reducer = getNewReducer()

export default (state, action) => {
  if (action.type === unauthorizeUser.getType()) {
    return reducer(createStore(getNewReducer()).getState())
  }

  if (action.type === receiveMockState.getType()) {
    return reducer(action.payload)
  }

  return reducer(state, action)
}